export enum NotificationTypes {
	CALENDAR_BOOKING_NEW = "CALENDAR_BOOKING_NEW",
	CALENDAR_BOOKING_APPROVED = "CALENDAR_BOOKING_APPROVED",
	CALENDAR_BOOKING_REJECTED = "CALENDAR_BOOKING_REJECTED",
	CALENDAR_BOOKING_HOST_CANCELED = "CALENDAR_BOOKING_HOST_CANCELED",
	CALENDAR_BOOKING_USER_CANCELED = "CALENDAR_BOOKING_USER_CANCELED",
	CALENDAR_BOOKING_REMIND_REPLY = "CALENDAR_BOOKING_REMIND_REPLY",
}
